module.exports = __webpack_public_path__ + "static/img/05.f052e5ff.jpg";